// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__19W6m","errors":"Errors_errors__1HS9_"};